import { type Specialty } from '@/contracts';

import { API_PREFIX, send } from '../http';

export const catalogEndpoints = {
  listSpecialties() {
    // Public — the catalogue is what the mobile app and the public profile read
    // too, and it carries nothing an unauthenticated caller may not see.
    return send<Specialty[]>(`${API_PREFIX}/specialties`, { anonymous: true });
  },
};
